import {useState, useEffect} from 'react'
import {Box} from '@chakra-ui/react'
import frame1 from '../../../images/confetti_backgrounds/1.svg'
import frame2 from '../../../images/confetti_backgrounds/2.svg'
import frame3 from '../../../images/confetti_backgrounds/3.svg'
import frame4 from '../../../images/confetti_backgrounds/4.svg'
import frame5 from '../../../images/confetti_backgrounds/5.svg'
import frame6 from '../../../images/confetti_backgrounds/6.svg'
import frame7 from '../../../images/confetti_backgrounds/7.svg'
import frame8 from '../../../images/confetti_backgrounds/8.svg'
import frame9 from '../../../images/confetti_backgrounds/9.svg'
import frame10 from '../../../images/confetti_backgrounds/10.svg'
import frame11 from '../../../images/confetti_backgrounds/11.svg'
import frame12 from '../../../images/confetti_backgrounds/12.svg'
import frame13 from '../../../images/confetti_backgrounds/13.svg'
import frame14 from '../../../images/confetti_backgrounds/14.svg'
import frame15 from '../../../images/confetti_backgrounds/15.svg'
import frame16 from '../../../images/confetti_backgrounds/16.svg'
import frame17 from '../../../images/confetti_backgrounds/17.svg'
import frame18 from '../../../images/confetti_backgrounds/18.svg'
import frame19 from '../../../images/confetti_backgrounds/19.svg'

const frames = [
  frame1,
  frame2,
  frame3,
  frame4,
  frame5,
  frame6,
  frame7,
  frame8,
  frame9,
  frame10,
  frame11,
  frame12,
  frame13,
  frame14,
  frame15,
  frame16,
  frame17,
  frame18,
  frame19,
]

const ConfettiModalOverlay = () => {
  const [currentFrame, setCurrentFrame] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFrame((prev) => {
        if (prev === null || prev >= frames.length - 1) return null
        return prev + 1
      })
    }, 100)
    return () => clearInterval(interval)
  }, [])

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      w="100%"
      h="100%"
      overflow="hidden"
      pointerEvents="none"
    >
      {frames.map((src, i) => (
        <img
          // eslint-disable-next-line react/no-array-index-key
          key={`confetti_background_${i}`}
          src={src}
          alt=""
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: currentFrame === i ? 'block' : 'none',
          }}
        />
      ))}
    </Box>
  )
}

export default ConfettiModalOverlay
